import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-procure-aqui',
  templateUrl: './procure-aqui.component.html',
  styleUrls: ['./procure-aqui.component.scss']
})
export class ProcureAquiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
